export default __webpack_public_path__ + "static/media/block-image.437dabff.svg";